var _rect, _g, _path, _g2, _g3, _path2, _path3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBomb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    transform: "translate(19.0001 19)",
    fill: "#16171F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.0001,
    cy: 64,
    r: 34,
    fill: "url(#paint0_radial_1_281)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8402 32.132C73.944 31.6051 72.798 31.9178 72.2805 32.8303L68.9599 38.6862C67.4653 38.423 65.9273 38.2857 64.3572 38.2857C49.8006 38.2857 38.0001 50.0862 38.0001 64.6429C38.0001 79.1995 49.8006 91 64.3572 91C78.9139 91 90.7143 79.1995 90.7143 64.6429C90.7143 57.0816 87.5304 50.264 82.4301 45.4576L85.2629 40.4619C85.7803 39.5493 85.4733 38.3825 84.577 37.8557L74.8402 32.132Z",
    fill: "#34384F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.126 28.0072C91.5853 27.8472 95.5408 30.402 97.7929 32.6317C98.536 33.3674 98.536 34.5603 97.7929 35.296C97.0498 36.0317 95.845 36.0317 95.1019 35.296C93.2312 33.4439 90.2415 31.6657 87.2639 31.7726C84.542 31.8702 81.0937 33.593 78.2215 40.3467C77.8137 41.3056 76.698 41.7557 75.7294 41.3519C74.7609 40.9482 74.3063 39.8435 74.7141 38.8846C77.9309 31.3205 82.4111 28.1764 87.126 28.0072Z",
    fill: "#F82F2F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2809 32.8303C72.7984 31.9178 73.9444 31.6052 74.8406 32.132L84.5774 37.8557C85.4736 38.3825 85.7807 39.5494 85.2633 40.4619L80.5541 48.7666L67.5717 41.1351L72.2809 32.8303Z",
    fill: "#34384F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4647 64.6429C90.4647 79.0615 78.7762 90.75 64.3576 90.75C49.939 90.75 38.2505 79.0615 38.2505 64.6429C38.2505 50.2243 49.939 38.5357 64.3576 38.5357C78.7762 38.5357 90.4647 50.2243 90.4647 64.6429Z",
    fill: "#34384F",
    stroke: "url(#paint1_linear_1_281)",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4291 64.2492C89.4291 77.9592 78.1285 89.0714 64.1886 89.0714C59.2159 89.0791 54.3528 87.6354 50.2149 84.9233C53.6116 86.4133 57.2901 87.1806 61.0094 87.1751C75.6411 87.1751 87.5021 75.5119 87.5021 61.1227C87.509 57.4626 86.7287 53.8425 85.2123 50.5C87.9711 54.5714 89.4387 59.3566 89.4291 64.2492Z",
    fill: "url(#paint2_linear_1_281)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.4711 57.5968C45.863 62 49.3817 66.9163 49.3817 66.9163L48.7907 71.334L52.0744 72.4487L53.1823 68.0806L54.3974 68.1387L54.2513 73.1846L57.9207 73.4932L58.6258 68.9908C58.6258 68.9908 59.6607 68.9133 59.8067 69.0247C59.9528 69.136 59.5009 74.0633 59.5009 74.0633L62.7926 74.2L63.4247 69.1953C66.0341 68.9714 70.412 66.1417 71.3362 62.242C72.6289 57.3197 69.2037 50.5334 60.5187 49.2069C51.8336 47.8803 47.0815 53.1997 46.4711 57.5968ZM63.8526 56.8198C65.3438 57.4782 65.9348 59.5878 65.1727 61.5304C64.4105 63.4729 62.5838 64.5138 61.0903 63.8542C59.5968 63.1946 59.008 61.091 59.7736 59.1472C60.5392 57.2035 62.3613 56.165 63.8526 56.8234V56.8198ZM53.2701 54.922C54.5936 55.0612 55.5338 56.5753 55.3718 58.3C55.2098 60.0247 54.0026 61.3052 52.6779 61.1649C51.3533 61.0245 50.4131 59.5115 50.5763 57.788C50.7394 56.0645 51.9432 54.7792 53.2701 54.922Z",
    fill: "url(#paint3_linear_1_281)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5005 74.2C70.619 74.2 77.2005 67.3052 77.2005 58.8C77.2005 50.2948 70.619 43.4 62.5005 43.4C54.3819 43.4 47.8005 50.2948 47.8005 58.8C47.8005 67.3052 54.3819 74.2 62.5005 74.2Z",
    fill: "url(#paint4_radial_1_281)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_281",
    x: 0.0000610352,
    y: 0.0000305176,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_1_281"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_281",
    x: 74.5645,
    y: 28,
    width: 23.7857,
    height: 13.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.357955 0 0 0 0 0.396477 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_281"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_281",
    x: 67.5717,
    y: 27.8761,
    width: 17.9429,
    height: 20.8905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_281"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_281",
    x: 37.8005,
    y: 33.4,
    width: 49.4,
    height: 50.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1_281"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_281",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.0001 64) rotate(90) scale(34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E202E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_281",
    x1: 45.7005,
    y1: 46.9,
    x2: 64.6005,
    y2: 67.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686C88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_281",
    x1: 69.8221,
    y1: 50.5,
    x2: 69.8221,
    y2: 89.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704F4F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_281",
    x1: 59.0005,
    y1: 49,
    x2: 59.0005,
    y2: 74.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_281",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.5005 58.8) rotate(90) scale(15.4 14.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.fd9d7e6aba2a6f54b0d0163cb4209ed1.svg";
export { ForwardRef as ReactComponent };